
import { useParams } from "react-router-dom"
import { useEffect } from "react"
import { BackButton, Card, CustomButton, ShareModal } from "../../components"
import { useSelector } from "react-redux"
import { useState } from "react"
import { COLORS } from "../../constants"
import styled from "styled-components"
import Grey from "../../assets/images/Grey.svg"
import Gold from "../../assets/images/Gold.svg"
import Bronze from "../../assets/images/Bronze.svg"
import share from "../../assets/images/share.svg"
import lock from "../../assets/images/Lock.svg"
import axios from "axios"

const StyledCardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
    margin-top: 10px;
`;
const StyledCardWrapper = styled.div`
    padding: 5px;
`;

export default function LevelGamesResults() {
    let { levelno } = useParams();
    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user.user);
    // const [loading, setLoading] = useState(false);
    const [shareVisible, setShareVisible] = useState(false);
    const [gameResults, setGameResults] = useState([]);
    const [correct, setCorrect] = useState(0);

    const countCorrectlyAnswered = (res) => {
        let correctAnswered = 0;
        res.map(game => {
            if (game.played) {
                correctAnswered += game.data.score;
            }
        })
        return correctAnswered;
    }
    useEffect(() => {
        // setLoading(true)
        axios.get(`${api}/cp/pupil_levels_by_levels/${user.pupil_id}/${levelno}`, {}, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {

            const result = res.data.data;
            setGameResults(result);
            setCorrect(countCorrectlyAnswered(result));

        }).catch(error => {
            alert("Error occured. Try to reload a page or contact us.")
        });
    }, [])
    return (
        <div>
            <ShareModal levelno={levelno} visible={shareVisible} onClose={() => setShareVisible(false)} />

            <BackButton to="/dashboard" />
            <h4 className="color-text-green text-center mb-5">Level {levelno} Results</h4>

            <div className="d-flex justify-content-center">
                <img src={Bronze} className="mx-1" width="40" style={{ opacity: correct >= 100 ? '1' : '0.3' }} />
                <img src={Grey} className="mx-1" width="40" style={{ opacity: correct >= 200 ? '1' : '0.3' }} />
                <img src={Gold} className="mx-1" width="40" style={{ opacity: correct >= 300 ? '1' : '0.3' }} />
            </div>
            <StyledCardContainer className="mt-3">
                {gameResults.map((game, i) => {
                    if (game.played) {
                        return <StyledCardWrapper className="xs-grid-card" key={i}>
                            <Card className="px-3 text-center d-flex justify-content-center align-items-center flex-column" style={{ height: 130 }}>
                                <div className="mb-3">Game {game.game_no}</div>
                                <h4 className="color-orange">{game.data.score}<span className="color-dark-orange">/{game.data.max_score}</span></h4>
                            </Card>
                        </StyledCardWrapper>
                    } else {
                        return <StyledCardWrapper className="xs-grid-card" key={i}>
                            <Card className="px-3 text-center d-flex justify-content-center align-items-center flex-column" style={{ height: 130 }}>
                                <div className="mb-3" style={{ marginTop: "-10px" }}>Game {game.game_no}</div>
                                <span className="color-text-grey">No Results</span>
                            </Card>
                        </StyledCardWrapper>
                    }

                })}

                {[...Array(50 - gameResults.length)].map((details, i) =>
                    <StyledCardWrapper className="xs-grid-card" key={i}>
                        <Card className="px-3 text-center" style={{ padding: "38.5px 0" }}>
                            <img src={lock} />
                        </Card>
                    </StyledCardWrapper>
                )}

            </StyledCardContainer>
            <div className="text-right mt-3 mb-4">
                <CustomButton onClick={() => setShareVisible(true)} className="px-4" bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover}>
                    <img src={share} width="20" className="mr-2" style={{ marginBottom: "3px" }} />Share Progress
                </CustomButton>
            </div>
        </div >
    )
}
